const GenerateFrontendUrl = ()=>{
    switch(process.env.REACT_APP_MODE){
        case 'staging': return "http://192.119.91.91:3000/";
        case 'production': return "https://festivmedia.com/";
        default: return "http://localhost:3000/";
    }
};
const GenerateBackendUrl = ()=>{
    switch(process.env.REACT_APP_MODE){
        case 'staging': return "http://192.119.91.91/";
        case 'production': return "https://dashboard.festivmedia.com/";
        default: return 'http://192.119.91.91/'; // "http://192.119.91.91/"; // 'http://127.0.0.1:8000/';
    }
};

const GetAwsDetails = ()=>{
    return {
        AWS_ACCESS_KEY: process.env.REACT_APP_AWS_ACCESS_KEY ,
        AWS_SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_SECRET_KEY ,
        AWS_S3_BUCKET_NAME: process.env.REACT_APP_AWS_S3_BUCKET_NAME ,
        AWS_S3_REGION: process.env.REACT_APP_AWS_S3_REGION ,
    };
};

export const FRONTEND_URL = GenerateFrontendUrl();
export const BACKEND_URL = GenerateBackendUrl();
export const { AWS_ACCESS_KEY, AWS_SECRET_ACCESS_KEY, AWS_S3_BUCKET_NAME, AWS_S3_REGION } = GetAwsDetails();